import React from "react";
import { Grid } from "@mui/material";
import StatsCards from "../StatsCards";
import SalesStatistics from "../SalesStatistics";
import RevenueByArea from "../RevenueByArea";

import NewMembers from "../NewMembers";
import RecentActivities from "../RecentActivities";
import MarketingChannel from "../MarketingChannel";
import LatestOrders from "../LatestOrders";

const Dashboard = () => {
  return (
    <>
      {/* Stats Cards */}
      <StatsCards />

      {/* Sales Statistics and Revenue By Area */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <SalesStatistics />
        </Grid>
        <Grid item xs={12} md={6}>
          <RevenueByArea />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} md={3} lg={3}> 
          <NewMembers />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <RecentActivities />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}> 
          <MarketingChannel />
        </Grid>
      </Grid>
      <LatestOrders />

    </>
  );
};

export default Dashboard;
